





import Vue from 'vue'
import Mappa from '../components/mapplants/Mappa.vue'
import Azioni from '../components/mapplants/Azioni.vue'
import {mapActions, mapGetters} from 'vuex'

export default Vue.extend({
    metaInfo: {
        title: 'Map Plants',
        link: [
            {rel: 'apple-touch-icon', sizes: '57x57', href: '/mapplants/favicon/apple-icon-57x57.png'},
            {rel: 'apple-touch-icon', sizes: '60x60', href: '/mapplants/favicon/apple-icon-60x60.png'},
            {rel: 'apple-touch-icon', sizes: '72x72', href: '/mapplants/favicon/apple-icon-72x72.png'},
            {rel: 'apple-touch-icon', sizes: '76x76', href: '/mapplants/favicon/apple-icon-76x76.png'},
            {rel: 'apple-touch-icon', sizes: '114x114', href: '/mapplants/favicon/apple-icon-114x114.png'},
            {rel: 'apple-touch-icon', sizes: '120x120', href: '/mapplants/favicon/apple-icon-120x120.png'},
            {rel: 'apple-touch-icon', sizes: '144x144', href: '/mapplants/favicon/apple-icon-144x144.png'},
            {rel: 'apple-touch-icon', sizes: '152x152', href: '/mapplants/favicon/apple-icon-152x152.png'},
            {rel: 'apple-touch-icon', sizes: '180x180', href: '/mapplants/favicon/apple-icon-180x180.png'},
            {
                rel: 'icon',
                type: 'image/png',
                sizes: '192x192',
                href: '/mapplants/favicon/android-icon-192x192.png'
            },
            {rel: 'icon', type: 'image/png', sizes: '32x32', href: '/mapplants/favicon/favicon-32x32.png'},
            {rel: 'icon', type: 'image/png', sizes: '96x96', href: '/mapplants/favicon/favicon-96x96.png'},
            {rel: 'icon', type: 'image/png', sizes: '16x16', href: '/mapplants/favicon/favicon-16x16.png'},
            {rel: 'manifest', href: '/mapplants/favicon/manifest.json'}
        ],
        meta: [
            {name: 'msapplication-TileColor', content: '#159957'},
            {name: 'msapplication-TileImage', content: '/mapplants/favicon/ms-icon-144x144.png'},
            {name: 'theme-color', content: '#159957'}
        ]
    },
    components: {
        Mappa,
        Azioni
    },
    props: {
        comune: String
    },
    computed: {
        ...mapGetters('user', ['eUnOperatoreGestionaleMapplants'])
    },
    methods: {
        ...mapActions('mapplantsMappa', ['caricaStatoRilevamenti', 'caricaRilevamenti']),
        ...mapActions('mapplantsPuntiDiInteresse', ['caricaPuntiDiInteresse'])
    },
    created() {
        // carichiamo le cose
        this.caricaRilevamenti()
        this.caricaStatoRilevamenti()
        this.caricaPuntiDiInteresse()
    }
})
